import { render, staticRenderFns } from "./WheelBattleRankTab.vue?vue&type=template&id=70f7f00f&scoped=true&"
import script from "./WheelBattleRankTab.vue?vue&type=script&lang=js&"
export * from "./WheelBattleRankTab.vue?vue&type=script&lang=js&"
import style0 from "./WheelBattleRankTab.vue?vue&type=style&index=0&id=70f7f00f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f7f00f",
  null
  
)

export default component.exports